import { request } from '../request';

// 用于在途请求去重 (In-flight request deduplication)，防止 React 严格模式或双重挂载引发重复网络请求
const inFlightRequests = new Map<string, Promise<any>>();

function getDeduplicatedRequest<T>(cacheKey: string, requestFn: () => Promise<T>): Promise<T> {
  if (inFlightRequests.has(cacheKey)) {
    return inFlightRequests.get(cacheKey)!;
  }

  const promise = requestFn().finally(() => {
    setTimeout(() => {
      inFlightRequests.delete(cacheKey);
    }, 300);
  });

  inFlightRequests.set(cacheKey, promise);
  return promise;
}

/**
 * 获取我的站内消息列表
 * GET /my/messages
 *
 * @param params 分页及筛选参数 (page, page_size, is_read, message_type)
 * @returns 站内消息分页响应
 */
export function fetchMyMessages(params?: Api.Notification.GetMessagesParams) {
  const cacheKey = `messages:list:${params?.page || 1}:${params?.page_size || 20}:${params?.is_read}:${params?.message_type || 'all'}`;
  return getDeduplicatedRequest(cacheKey, () =>
    request<Api.Notification.MessagePageResponse>({
      url: '/my/messages',
      method: 'get',
      params,
    })
  );
}

/**
 * 标记站内消息为已读
 * POST /my/messages/{id}/read
 *
 * @param id 消息 ID
 * @returns 标记结果
 */
export function markMessageRead(id: string | number) {
  return request<Api.Notification.MarkReadResponse>({
    url: `/my/messages/${id}/read`,
    method: 'post',
  });
}

/**
 * 将我的全部未读消息标记为已读
 * POST /my/messages/read-all
 *
 * @returns 全部标记已读结果
 */
export function markAllMessagesRead() {
  return request<Api.Notification.ReadAllResponse>({
    url: '/my/messages/read-all',
    method: 'post',
  });
}

/**
 * 获取我的未读消息数量
 * GET /my/messages/unread-count
 *
 * @returns 未读消息数量
 */
export function fetchUnreadMessageCount() {
  return getDeduplicatedRequest('messages:unread-count', () =>
    request<Api.Notification.UnreadCountResponse>({
      url: '/my/messages/unread-count',
      method: 'get',
    })
  );
}
